<div class="modal-container">
  <div class="modal-header">
    <div class="header-title">
      <h2>{{ 'home.privacy-policy.dialog.title' | translate }}</h2>
    </div>
    <svg class="header-divider" width="768" height="1" viewBox="0 0 768 1" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0H768V1H0V0Z" fill="white"></path>
    </svg>
  </div>

  <div class="modal-body">
    <div class="options">
      <button class="option-btn privacy" [ngClass]="{ active: selectedOption === PolicyOptions.Privacy }" (click)="selectOption(PolicyOptions.Privacy)">
        {{ 'home.privacy-policy.dialog.privacy-section.privacy-button' | translate }}
      </button>
      <button class="option-btn cookies" [ngClass]="{ active: selectedOption === PolicyOptions.Cookies }" (click)="selectOption(PolicyOptions.Cookies)">
        {{ 'home.privacy-policy.dialog.cookies-section.cookies-button' | translate }}
      </button>
    </div>
    <svg class="vertical-divider" width="1" height="470" viewBox="0 0 1 470" xmlns="http://www.w3.org/2000/svg">
      <line x1="0.5" y1="470" x2="0.5" stroke="white"></line>
    </svg>
    <div class="body-text scrollable-content" *ngIf="selectedOption === PolicyOptions.Privacy">
      <h3>{{ 'home.privacy-policy.dialog.privacy-section.title' | translate }}</h3>
      <div class="policy-text" [innerHTML]="'home.privacy-policy.dialog.privacy-section.text' | translate"></div>
      <div class="text-icon"></div>
    </div>

    <div class="body-text scrollable-content" *ngIf="selectedOption === PolicyOptions.Cookies">
      <h3>{{ 'home.privacy-policy.dialog.cookies-section.title' | translate }}</h3>
      <div class="policy-text" [innerHTML]="'home.privacy-policy.dialog.cookies-section.text' | translate"></div>
      <div class="text-icon"></div>
    </div>
  </div>

  <div class="modal-footer">
    <svg class="footer-divider" width="768" height="1" viewBox="0 0 768 1" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0H768V1H0V0Z" fill="white"></path>
    </svg>
    <div class="footer-actions">
      <button mat-icon-button mat-dialog-close (click)="onClose()" class="close-btn">
        <span class="ok-text">Ok</span>
      </button>
    </div>
  </div>
</div>
